import HomBinocularsIcon from '~/components/Icons/svgs/HomBinocularsIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { IconName } from '~/components/Icons/types'

export default function PanelTitle({ title, icon }: { title: string; icon?: IconName }): React.ReactElement {
  const getIconComponent = (name: string): ((props: { [key: string]: any }) => React.ReactElement) => {
    switch (name) {
      case 'hom-binoculars':
        return HomBinocularsIcon
      default:
        return HomBinocularsIcon
    }
  }

  return (
    <header className="mb-2 space-x-2 flex items-center">
      {icon && <SVGIcon icon={getIconComponent(icon)} size={24} />}
      <h1 className="flex-1 text-center lg:text-left text-lg">{title}</h1>
    </header>
  )
}
